<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="padding-top: 2vh; width: 90%; margin: auto; text-align: center">

    <div style="width: 45%; margin: auto;">
      <h3 class="textXM" style="text-align: center; border-bottom: 2px solid #18264f">
        {{this.localiser.get("menu.parameters")}}
      </h3>
    </div>

    <div class="row">

      <div class="col-3 searcherDiv">
          <span class="material-icons-outlined textXXM centerVert" style="color: #18264F; width: 15%; height: 65%">
            search
          </span>
        <input [(ngModel)]="searcherLuminarias" type="text" class="textS searcherInput centerVert"
               placeholder="{{this.localiser.get('ota.search')}}" (input)="checkAllFilters()" maxlength="50">
      </div>

      <div class="col-3">
        <mat-select (selectionChange)="selectPlano($event.value)" [(ngModel)]="planoSelected" [placeholder]="this.localiser.get('ota.filterFloorplan')" class="selectFilter textS">
          <mat-option class="textS+" [value]="'all'"><b>{{this.localiser.get("ota.filterAll")}}</b></mat-option>
          <mat-option class="textS+" *ngFor="let plano of planos" [value]="plano">{{plano.nombre}}</mat-option>
        </mat-select>
      </div>

      <div class="col-3">
        <mat-select (selectionChange)="selectZona($event.value)" [(ngModel)]="zonaSelected" [placeholder]="this.localiser.get('ota.filterZone')" class="selectFilter textS">
          <mat-option class="textS+" [value]="'all'"><b>{{this.localiser.get("ota.filterAll")}}</b></mat-option>
              <mat-option class="textS+" *ngFor="let zona of showZonas" [value]="zona">{{zona.nombre}}</mat-option>
        </mat-select>
      </div>

    </div>
    <div class="row">

      <!-- Luminarie list Col -->
      <div class="col-4" style="margin-top: 1%">
        <h4 class="textS+" style="text-decoration: underline; margin: auto;">
          {{this.localiser.get("parameters.lumList")}}
        </h4>
        <div class="luminariasList">
          <div *ngFor="let luminaria of this.luminarias; index as i" class="luminariaBox">
            <div (click)="changeSelectLum(luminaria)" class="row luminariaRow"
                 [ngClass]="{luminariaSelectedRow: lumSelected != undefined && lumSelected.idDispositivo == luminaria.idDispositivo}">
              <div class="row luminariaRowUp">
                <div class="col-6 luminariaColRight">
                  <h3 class="centerVert textS marginAuto">{{luminaria.nombre}}</h3>
                </div>
                <div class="col-6">
                  <h3 class="centerVert textS marginAuto">{{luminaria.idDispositivo}}</h3>
                </div>
              </div>
              <div class="row luminariaRowBottom">
                <div class="col-6 luminariaColRight">
                  <h3 class="centerVert textXS marginAuto">{{getPlanoNameById(luminaria.idPlano)}}</h3>
                </div>
                <div class="col-6">
                  <h3 class="centerVert textXS marginAuto">{{getZonaNameById(luminaria.idZona)}}</h3>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!loadingLums && this.luminarias.length == 0" class="noLuminaries">
            <h3 class="centerVert textM marginAuto">{{this.localiser.get("parameters.noLuminaries")}}</h3>
          </div>

          <div *ngIf="loadingLums" class="noLuminaries">
            <mat-progress-spinner class="marginAuto" mode="indeterminate" diameter="50">
            </mat-progress-spinner>
          </div>

        </div>

      </div>

      <!-- Luminarie Selected Col -->
      <div *ngIf="lumSelected != undefined" class="col-8" style="margin-top: 2%">
        <div class="marginAuto" style="height: 90%">
          <div class="row">
            <h1 class="textS+ marginAuto">{{this.localiser.get("parameters.parametersOf")}}: <b>{{lumSelected.nombre}} ({{lumSelected.idDispositivo}})</b></h1>
          </div>
          <div class="row" style="margin: auto; width: 50%">
            <mat-select id="selector-parametro" (ngModelChange)="changeSelectType($event)" [(ngModel)]="parametrosTipoSelected" placeholder="TYPE" class="selectFilter textS">
              <mat-option class="textS" *ngFor="let tipo of parametrosTipo" [value]="tipo">{{tipo.text}}</mat-option>
            </mat-select>
          </div>

          <!-- TABLE PARAMETERS -->
          <div class="deviceTable" *ngIf="!gettingParameters && parametros.length > 0">

            <table *ngIf="parametrosTipoSelected?.type != 'MapOfHubs'" style="width:100%; white-space: nowrap">
              <tr class="bottom-border" style="background: rgba(213, 211, 224) !important">
                <th class="separator textS col-4">{{this.localiser.get("parameters.parameter")}}</th>
                <th class="separator textS col-7">{{this.localiser.get("parameters.input")}}</th>
                <th class="separator textS col-1">{{this.localiser.get("parameters.unit")}}</th>
              </tr>
              <tr *ngFor="let parametro of parametros">
                <td class="separator textS col-4">{{this.localiser.get("parameters.parameter." + parametro.parametro)}}</td>
                <td class="separator textS col-7">
                  <input *ngIf="parametro.tipoDato == 'int'" class="textS" style="width: 90%; margin: 2% auto" type="number" [max]="parametro.max" [min]="parametro.min"
                         [(ngModel)]="parametro.value" (ngModelChange)="changeParameterNumber(parametro)"
                         [disabled]="loadingParameters || settingParameters || parametro.tipo == 'Zone'
                          || parametro.tipo == 'Group' || parametro.tipo == 'Fade' || parametro.tipo == '4.20mA'">
                  <input *ngIf="parametro.tipoDato == 'float'" class="textS" style="width: 90%; margin: 2% auto" type="number" step=".1" [max]="parametro.max" [min]="parametro.min"
                         [(ngModel)]="parametro.value" (ngModelChange)="changeParameterNumber(parametro)"
                         [disabled]="loadingParameters || settingParameters || parametro.tipo == 'Zone'
                          || parametro.tipo == 'Group' || parametro.tipo == 'Fade' || parametro.tipo == '4.20mA'">
                  <input *ngIf="parametro.tipoDato == 'custom'" class="textS" style="width: 90%; margin: 2% auto" type="number" [max]="parametro.max" [min]="parametro.min"
                         placeholder="{{getCustomValue(parametro.parametro, parametro.value)}}" disabled>
                  <input *ngIf="parametro.tipoDato == 'binary'" class="textS" style="width: 90%; margin: 2% auto" type="number" [max]="parametro.max" [min]="parametro.min"
                         placeholder="{{dec2bin(parametro.value)}}" disabled>
                </td>
                <td class="separator textXS col-1">{{parametro.unit}}</td>
                </tr>
            </table>

            <table id="table-parameters" *ngIf="parametrosTipoSelected?.type == 'MapOfHubs'" style="width:100%; white-space: nowrap">
              <tr id="tr-1" class="bottom-border" style="background: rgba(213, 211, 224) !important">
                <th class="separator textS col-3">{{this.localiser.get("parameters.parameter")}}</th>
                <th class="separator textS col-8">{{this.localiser.get("parameters.input")}}</th>
                <th class="separator textS col-1"></th>
              </tr>

              <!-- MAP OF HUBS PARAMETERS -->
              <!-- MAIN HUB -->
              <tr id="tr-2">
                <td id="td-1" class="separator textS col-3">{{this.localiser.get("parameters.parameter." + parametros[0].parametro)}}</td>
                <td id="td-2" class="separator textS col-8">
                  <mat-select id="selector-parametro-1" (ngModelChange)="changeSelectMainHub(parametros[0], $event)" [(ngModel)]="mainHub" placeholder="TYPE" class="selectFilter textS">
                    <mat-option class="textS este" *ngFor="let gw of concentradoresMain" [value]="gw">{{gw.nombre}} - {{gw.idDispositivo}}</mat-option>
                  </mat-select>
                </td>
                <td class="separator textS col-1"></td>
              </tr>

              <!-- MNT HUB -->
              <tr id="tr-3">
                <td id="td-3" class="separator textS col-3">{{this.localiser.get("parameters.parameter." + parametros[1].parametro)}}</td>
                <td id="td-4" class="separator textS col-8">
                  <h3 *ngIf="mntHub != undefined" style="margin: 3%" class="textS">{{mntHub.nombre}} - {{mntHub.idDispositivo}}</h3>
                  <h3 *ngIf="mntHub == undefined" style="margin: 3%" class="textS">{{this.localiser.get("parameters.noMnt")}}</h3>
                </td>
                <td id="td-5" class="separator textS col-1"></td>
              </tr>

              <!-- ALT HUBS -->
              <tr id="tr-4" *ngFor="let altHub of altHubs; index as i">
                <td id="td-6" class="separator textS col-3">{{this.localiser.get("parameters.parameter." + parametros[2].parametro)}} {{i + 1}}</td>
                <td id="td-7" class="separator textS col-8">
                  <mat-select id="selector-parametro-2" (ngModelChange)="changeSelectAltHub(parametros[2], i, $event)" [(ngModel)]="altHubs[i]" placeholder="Alt Hub" class="selectFilter textS">
                    <mat-option class="textS" *ngFor="let gw of availableAltHubs(altHubs[i])" [value]="gw">{{gw.nombre}} - {{gw.idDispositivo}}</mat-option>
                  </mat-select>
                </td>
                <!-- REMOVE ALT HUB -->
                <td id="td-8" class="separator textS col-1">
                  <span (click)="rmAltHub(parametros[2], i)" class="material-icons-outlined buttonRmAlt textXM">
                  remove_circle_outline
                  </span>
                </td>
              </tr>
              <!-- ADD ALT HUBS -->
              <tr id="tr-5" *ngIf="canAddAltHub()">
                <td id="td-9" colspan="3">
                  <span (click)="addAltHub()" class="material-icons-outlined buttonAddAlt textXM">
                    add_circle_outline
                  </span>
                </td>
              </tr>
            </table>
          </div>

          <!-- BUTTON TO MODIFY ZONE -->
          <div style="margin-top: 2%" *ngIf="!gettingParameters && !checkNoData() && parametrosTipoSelected?.type == 'Zone'">
            <div (click)="toZone()" class="customIconButton">
              <div class="col-8" style="margin: 5% 0">
                <h3 class="textS marginAuto">{{this.localiser.get("parameters.modifyInZones")}}</h3>
              </div>
              <div class="col-4">
                <span class="material-icons-outlined textXXM centerVert">smart_button</span>
              </div>
            </div>
          </div>

          <!-- BUTTON TO MODIFY GROUPS AND PROFILE -->
          <div style="margin-top: 2%" class="deviceTable" *ngIf="!gettingParameters && !checkNoData()
          && (parametrosTipoSelected?.type == 'Group' || parametrosTipoSelected?.type == 'Fade')">
            <div (click)="toFade()" class="customIconButton">
              <div class="col-8" style="margin: 5% 0">
                <h3 class="textS marginAuto">{{this.localiser.get("parameters.modifyInGroups")}}</h3>
              </div>
              <div class="col-4">
                <span class="material-icons-outlined textXXM centerVert">settings_suggest</span>
              </div>
            </div>
          </div>

          <!-- BUTTON TO MODIFY 4-20 SENSOR TRHESHOLDS -->
          <div style="margin-top: 2%" class="deviceTable" *ngIf="!gettingParameters && !checkNoData() && parametrosTipoSelected?.type == '4.20mA'">
            <div (click)="toThresholds()" class="customIconButton">
              <div class="col-8" style="margin: 5% 0">
                <h3 class="textS marginAuto">{{this.localiser.get("parameters.modifyInThresholds")}}</h3>
              </div>
              <div class="col-4">
                <span class="material-icons-outlined textXXM centerVert">sort</span>
              </div>
            </div>
          </div>

          <!-- NO DATA DIV -->
          <div *ngIf="checkNoData()" class="row" style="margin-top: 10%">
            <h3 class="textM" style="margin: auto">{{this.localiser.get("parameters.noData")}}</h3>
          </div>

          <!-- LOADING SPINNER -->
          <div *ngIf="gettingParameters" class="row" style="margin-top: 10%">
            <h3 class="textM" style="margin: auto 2% auto 25%">Loading parameters</h3>
            <mat-progress-spinner mode="indeterminate" diameter="50">
            </mat-progress-spinner>
          </div>

        </div>

        <!-- DOWN BUTTONS ROW -->
        <div style="height: 10%">
          <div *ngIf="parameterRequestPending" class="row" style="margin-bottom: 1%">
            <div class="col-12" style="text-align: center">
              <h3 class="textS" style="color: #18264F; margin: 0">
                {{parameterRequestMessage}}
              </h3>
            </div>
          </div>
          <div class="row marginAuto centerVert">
            <div class="col-4">
              <div (click)="loadParametrosFromGW()" class="customIconButton"
                   [ngClass]="{disabledIconButton: settingParameters,
                   customButtonColorReverse: loadingParameters}">
                <div class="col-8" style="margin: 5% 0">
                  <h3 class="textS+ marginAuto">{{this.localiser.get("button.refresh")}}</h3>
                </div>
                <div class="col-4">
                  <span *ngIf="!loadingParameters" class="material-icons-outlined textM centerVert">refresh</span>
                  <mat-progress-spinner *ngIf="loadingParameters" class="centerVert" mode="indeterminate" diameter="30">
                  </mat-progress-spinner>
                </div>
              </div>
              <div *ngIf="parametros.length > 0" style="margin-top: 2%">
                <h3 style="color: gray" class="textXS">{{this.localiser.get("parameters.last")}}: {{getLastComm(parametros[0].timestamp)}}</h3>
              </div>
            </div>
            <div class="col-4">
              <button (click)="resetParametros()" class="customIconButton">{{this.localiser.get("button.reset")}}</button>
            </div>
            <div class="col-4">
              <div id="button-update-parameters" (click)="setParametrosWithIdDispositivo()" class="customIconButton"
              [ngClass]="{disabledIconButton: (!checkParametroIsChanged() && !settingParameters) || loadingParameters,
               customButtonColorReverse: settingParameters}">
                <div class="col-8" style="margin: 5% 0">
                  <h3 class="textS+ marginAuto">{{this.localiser.get("button.update")}}</h3>
                </div>
                <div class="col-4">
                  <span *ngIf="!settingParameters" class="material-icons-outlined textM centerVert">update</span>
                  <mat-progress-spinner *ngIf="settingParameters" class="centerVert" mode="indeterminate" diameter="30">
                  </mat-progress-spinner>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
